export default {
  setSelections(state, val) {
    state.selections = val.selections
  }
}



// WEBPACK FOOTER //
// ./src/Adm/CPD/store/mutations.js